var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinglePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66673 7.33333H13.3334C13.7016 7.33333 14.0001 7.63181 14.0001 8C14.0001 8.36819 13.7016 8.66667 13.3334 8.66667H8.66673V13.3333C8.66673 13.7015 8.36825 14 8.00006 14C7.63187 14 7.33339 13.7015 7.33339 13.3333V8.66667H2.66673C2.29854 8.66667 2.00006 8.36819 2.00006 8C2.00006 7.63181 2.29854 7.33333 2.66673 7.33333H7.33339V2.66667C7.33339 2.29848 7.63187 2 8.00006 2C8.36825 2 8.66673 2.29848 8.66673 2.66667V7.33333Z",
    fill: "#031D42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePlus);
export default __webpack_public_path__ + "static/media/single-plus.8b973cb5.svg";
export { ForwardRef as ReactComponent };